import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getGaMeasurementId, trackGaPageView } from './google-analytics'

/**
 * Sends GA4 virtual page views on client-side route changes (SPA).
 * Requires `send_page_view: false` on initial gtag config so the first hit is not duplicated.
 */
export const useGoogleAnalyticsPageViews = (): void => {
  const location = useLocation()

  useEffect(() => {
    if (!getGaMeasurementId()) return
    const path = `${location.pathname}${location.search}`
    trackGaPageView(path)
  }, [location.pathname, location.search])
}
